import { type FC, type ReactNode } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { ErrorIcon, Sizes, WarningIcon } from "@snapchat/snap-design-system-icons";

import { SubmissionQuotaSeverity } from "../../models/SubmissionQuota";

const severityIcons: Record<SubmissionQuotaSeverity, ReactNode> = {
    [SubmissionQuotaSeverity.Normal]: null,
    [SubmissionQuotaSeverity.Warning]: <WarningIcon size={Sizes.Small} fill={Colors.Orange.V100} aria-hidden />,
    [SubmissionQuotaSeverity.Urgent]: <WarningIcon size={Sizes.Small} fill={Colors.Orange.V200} aria-hidden />,
    [SubmissionQuotaSeverity.Exhausted]: <ErrorIcon size={Sizes.Small} fill={Colors.Red.V150} aria-hidden />,
};

export const QuotaSeverityIcon: FC<{ severity: SubmissionQuotaSeverity }> = ({ severity }) => severityIcons[severity];
